import * as React from 'react';
import './TextArea.scss';

interface IInputProps {
  label?: string;
  placeholder?: string;
  value: string;
  disabled?: boolean;
  required?: boolean;
  invalid?: boolean;
  invalidMessage?: string;
  className?: string;
  onChange(value: string): void;
  onKeyDown?(event: React.KeyboardEvent): void;
}

export function TextArea(props: IInputProps) {
  const className = `rp-textarea ${props.invalid ? 'invalid' : ''} ${
    props.disabled ? 'disabled' : ''
  }  ${props.className ? props.className : ''}`;
  return (
    <div className={className}>
      <label>
        {props.label}
        {props.required && <span className="required">*</span>}
      </label>
      <textarea
        value={props.value}
        placeholder={props.placeholder}
        onChange={event => props.onChange(event.target.value)}
        disabled={props.disabled}
        onKeyDown={props.onKeyDown}
      />
      <div className="rp-textarea--message">
        {props.invalid ? props.invalidMessage : null}
      </div>
    </div>
  );
}
